import { NavLink, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faToolbox, faBook, faEnvelope, faNewspaper, faRightFromBracket, faBug, faPills, faFileInvoiceDollar, faShop } from '@fortawesome/free-solid-svg-icons';
import { useBackofficeAuth } from '../context/BackofficeAuthProvider';

import './BackofficeSidebar.scss';

// Backoffice sections — add new modules here as they're built.
const navItems = [
    { label: 'Produits', icon: faPills, to: '/backoffice/products' },
    { label: 'Pharmacies', icon: faShop, to: '/backoffice/pharmacies' },
    { label: 'Abonnements', icon: faFileInvoiceDollar, to: '/backoffice/subscriptions' },
    { label: "Centre d'aide", icon: faBook, to: '/backoffice/help' },
    { label: 'Messages de contact', icon: faEnvelope, to: '/backoffice/contact-messages' },
    { label: 'Issues', icon: faBug, to: '/backoffice/issues' },
    { label: 'Newsletter', icon: faNewspaper, to: '/backoffice/newsletter-subscribers' },
];

export default function BackofficeSidebar() {
    const { admin, logout } = useBackofficeAuth();
    const navigate = useNavigate();

    const handleLogout = () => {
        logout().then(() => navigate('/backoffice/login', { replace: true }));
    };

    return (
        <div className="backoffice-sidebar">
            <div className="backoffice-sidebar__brand">
                <FontAwesomeIcon icon={faToolbox} />
                Saydalani
                <span className="backoffice-sidebar__badge">Backoffice</span>
            </div>

            <nav className="backoffice-sidebar__nav">
                {navItems.map((item) => (
                    <NavLink
                        key={item.to}
                        to={item.to}
                        className={({ isActive }) => `backoffice-sidebar__link ${isActive ? 'active' : ''}`}
                    >
                        <FontAwesomeIcon icon={item.icon} />
                        {item.label}
                    </NavLink>
                ))}
            </nav>

            <div className="backoffice-sidebar__footer">
                {admin?.username && <span className="backoffice-sidebar__user">{admin.username}</span>}
                <button type="button" className="backoffice-sidebar__logout" onClick={handleLogout}>
                    <FontAwesomeIcon icon={faRightFromBracket} />
                    Se déconnecter
                </button>
            </div>
        </div>
    );
}
